<template>
    <v-dialog
      v-model="dialog"
      :width="width"
    >
      <v-card>
          <v-toolbar
            :color="bgcolor"
            dense
            dark
            >
            <v-card-title >
                {{title}}
            </v-card-title>
            <v-spacer></v-spacer>  

            <ps-icon-button
                v-if="showCheckButton" small icon="check" :click="onCheck" style="color: #57d457;"/>
            &nbsp;
            <ps-icon-button small icon="close" :click="onClose" style="color:red"/>
          </v-toolbar>
          <v-spacer></v-spacer>
        <br/> <br/>
        <v-card-text>
          {{message}}
        </v-card-text>
         <br/> <br/>
      </v-card>
    </v-dialog>
</template>
<script>
import psButton from './ps-button.vue';
import PsIconButton from './ps-icon-button.vue';
export default {
  components: { psButton, PsIconButton },
    name: "psAlertPopup",
    props: {       
        showCheckButton: {
            type: Boolean,
            default: true,              
        },    
        checkCallback: {
            type: Function,
            default: ()=>{}
        },
        title: {
            type: String,
            required: true,          
        },
         message:  {
            type: String,
            required: true,          
        },
        bgcolor:  {
            type: String,
            required: false,    
            default: "#467FA5"     
        },
        width: {            
            type: String,
            required: false, 
            default: 600
        }
    }, 
    data() {
        return {
            dialog:true
        };        
    },
    methods: {
      // Gets column name from i18n.
        onCheck(event) {    
            if(this.checkCallback)    
                this.checkCallback();    

            this.dialog =false;    //show close animation        
            setTimeout(() => {
                this.$destroy(); //wait for animation to finish before distroy
            }, 1000);

        },    
        onClose(event) {  
            
            this.dialog =false;    //show close animation
            setTimeout(() => {
                this.$destroy(); //wait for animation to finish before distroy
            }, 1000);

            
        }
    }
    
};
</script>
<style>
.p4-report{
    .psTableDialog .tabulator-cell:hover {
        background-color: #90afc4 !important;
    }    
}
</style>